export function enhanceArrowLists() {
  document.querySelectorAll(".bodytext ul.arrow-list").forEach((list) => {
    list.querySelectorAll(":scope > li").forEach((item) => {
      if (item.querySelector(".arrow-list__icon")) {
        return;
      }

      const icon = document.createElement("i");
      icon.className = "arrow-list__icon";
      icon.dataset.lucide = "check";
      icon.setAttribute("aria-hidden", "true");
      item.insertBefore(icon, item.firstChild);
    });
  });
}
